import { PUCK_CONFIG } from "../constants";
import { FoodsIcon, IconMapping } from "@foodpilot/foods";
import { Box, Stack, Typography, useTheme } from "@mui/material";

type NativePuckTitleField = {
    label: string;
    icon: keyof IconMapping;
    subtitle?: string;
};

export const NativePuckTitleField = (props: NativePuckTitleField) => {
    const { label = "", icon = "edit", subtitle } = props;
    const theme = useTheme();

    return (
        <Stack
            direction="row"
            alignItems="flex-start"
            spacing={theme.spacing(0.5)}
            sx={{ mb: theme.spacing(1), pl: theme.spacing(0.5) }}
        >
            <span style={{ color: "var(--puck-color-grey-07)", marginTop: 2 }}>
                <FoodsIcon icon={icon} size={1} />
            </span>
            <Box>
                <Typography
                    variant="subtitle2"
                    sx={{
                        fontWeight: theme.typography.fontWeightBold,
                        fontFamily: PUCK_CONFIG.FontFamily,
                        color: "var(--puck-color-grey-05)",
                    }}
                >
                    {label}
                </Typography>
                {subtitle && (
                    <Typography
                        variant="caption"
                        sx={{
                            fontFamily: PUCK_CONFIG.FontFamily,
                            color: "var(--puck-color-grey-07)",
                            display: "block",
                        }}
                    >
                        {subtitle}
                    </Typography>
                )}
            </Box>
        </Stack>
    );
};

export default NativePuckTitleField;
